import { FC } from "react";
import SkeletonList from "../../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";
import MissingPartsWrongMaterialReason from "./MissingPartsWrongMaterialReason";
import { WarrantyItemForMissing } from "../../../types";
import { DialogContainer } from "./MissingPartsWrongMaterial.style";
import WarrantyBasketItems from "../WarrantyBasketItems";
import WarrantyBasketItemsHeader from "../WarrantyBasketItemsHeader";

type TMissingPartsWrongMaterial = {
    items: WarrantyItemForMissing[];
    loading: boolean;
    errorList: {key: string, indexes: string[]}[];
};

const MissingPartsWrongMaterial: FC<TMissingPartsWrongMaterial> = (props) => {
    const { items, loading, errorList } = props;

    return (
        <DialogContainer>
            {loading ? (
                <SkeletonList
                    mkey="MissingPartsWrongMaterial"
                    cols={6}
                    rowsForCell={2}
                    hasHeader
                />
            ) : (
                <>
                    <WarrantyBasketItemsHeader />
                    {items.map((item: WarrantyItemForMissing, idx: number) => (
                        <WarrantyBasketItems item={item} key={`${idx}_${item.code}_${item.navContext}`} readOnly={false}>
                            <MissingPartsWrongMaterialReason
                                item={item}
                                errorList={errorList}
                            />
                        </WarrantyBasketItems>
                    ))}
                </>
            )}
        </DialogContainer>
    );
};

export default MissingPartsWrongMaterial;
